import styled from 'styled-components';
import SideBarComponent from './SideBar';

const SideBar = styled(SideBarComponent)`
  z-index: 1;
  display: flex;
  .side-bar-content {
    border-right: 1px solid ${({ theme }) => theme.colors.dark[15]};
    background-color: ${({ theme }) => theme.colors.white[100]};
  }
`;

export default SideBar;
